var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 10.679L8.99998 16.25M8.99998 16.25L3.37498 10.679C3.00396 10.318 2.71171 9.88402 2.51664 9.40449C2.32157 8.92495 2.2279 8.41022 2.24153 7.89271C2.25517 7.3752 2.3758 6.86611 2.59585 6.39751C2.8159 5.92891 3.13058 5.51095 3.5201 5.16995C3.90961 4.82894 4.36551 4.57228 4.85909 4.41612C5.35267 4.25997 5.87324 4.2077 6.38801 4.26261C6.90278 4.31752 7.40061 4.47843 7.85014 4.73519C8.29967 4.99195 8.69117 5.33901 8.99998 5.75451C9.31013 5.34203 9.70208 4.998 10.1513 4.74396C10.6005 4.48993 11.0974 4.33135 11.6107 4.27815C12.124 4.22495 12.6428 4.27828 13.1346 4.4348C13.6263 4.59132 14.0805 4.84767 14.4686 5.18778C14.8568 5.5279 15.1706 5.94447 15.3903 6.41143C15.61 6.87839 15.731 7.38567 15.7457 7.90154C15.7604 8.41741 15.6684 8.93076 15.4756 9.40945C15.2827 9.88814 14.9932 10.3219 14.625 10.6835L8.99998 16.25Z",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.e9cc05a221effd2be48520ac8c3438d3.svg";
export { ForwardRef as ReactComponent };